


const EyetSVG = () => {
  return (
   <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.78996 5.99996C7.78996 6.98996 6.98996 7.78996 5.99996 7.78996C5.00996 7.78996 4.20996 6.98996 4.20996 5.99996C4.20996 5.00996 5.00996 4.20996 5.99996 4.20996C6.98996 4.20996 7.78996 5.00996 7.78996 5.99996Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.99992 10.1351C7.76492 10.1351 9.40992 9.09511 10.5549 7.29511C11.0049 6.59011 11.0049 5.40511 10.5549 4.70011C9.40992 2.90011 7.76492 1.86011 5.99992 1.86011C4.23492 1.86011 2.58992 2.90011 1.44492 4.70011C0.994922 5.40511 0.994922 6.59011 1.44492 7.29511C2.58992 9.09511 4.23492 10.1351 5.99992 10.1351Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  )
}

export default EyetSVG
